// extracted by mini-css-extract-plugin
export default {"productGrid":"kZ-z","centerLink":"lZ-z","productSection":"mZ-z","item":"nZ-z","ctaButton":"oZ-z"};